const UserRights = ({user, userTypes = [], children, condition = false}) => {
    const userType = user?.userType;

    const hasAccess =
        (Array.isArray(userTypes) && userTypes.includes(userType)) ||
        Boolean(condition);

    return hasAccess ? <>{children}</> : null;
};

export {UserRights};
